import React, { Component } from 'react';

/* 개발담당:양유빈
 * 화면기능:인증시 인증시간 만료 체크를 위한 Timmer 공통
 * -------- props --------
 * Minutes: 필수 | 타이머 설정 분
 * Seconds: 필수 | 타이머 설정 초
 * TimeOut: 옵션 | 타이머가 종료되었는지 확인 하는 ref 파라메터
*/

export class Timmer extends Component {
    static displayName = Timmer.name;

    constructor(props) {
        super(props);
        this.state = {
            Minutes: 0,
            Seconds: 0,
            TimeOut: false

        };
        this.refTimmer = React.createRef();
    }
    //초기화
    componentDidMount() {
        
    }
    //타이머 시작
    Play() {
        this.setState({ Minutes: this.props.Minutes, Seconds: this.props.Seconds });
        this.setState({ TimeOut: false });
        let countdown = setInterval(() => {
            let seconds = this.state.Seconds;
            if (parseInt(seconds) > 0) {
                this.setState({ Seconds: (parseInt(seconds) - 1) });
            }
            if (parseInt(seconds) === 0) {
                let minutes = this.state.Minutes;
                if (parseInt(minutes) === 0) {
                    clearInterval(countdown);
                    this.setState({ TimeOut: true });
                } else {
                    this.setState({ Seconds: 59, Minutes: parseInt(minutes) - 1 });
                }
            }
        }, 1000);
    }
    Stop() {
        this.setState({ Minutes: 0, Seconds: 0 });
    }
    //타이머 종료여부 체크
    isTimeOut() {
        return this.state.TimeOut;
    }
    render() {
        let seconds = this.state.Seconds;
        let minutes = this.state.Minutes;

        return (
            <div ref={this.refTimmer}>
                {minutes} : {seconds < 10 ? `0${seconds}` : seconds}
            </div>
        );
    }
}
